
const portfolioData = [
    {
        id:1,
        img:'assets/img/portfolio/duzce-osb.jpg',
        title:'Düzce OSB',
        subtitle:'',
        category:'Güvenlik Sistemleri',
        works:[
            "Profesyonel Kamara Sistemleri","Hırsız Alarm Sistemleri","Yangın Algılama Sistemleri","KVKK Çözümleri","Network Çözümleri","Fiber Çözümleri",""
        ]
        
    },
    {
        id:2,
        img:'assets/img/portfolio/gerede-osb.jpg',
        title:'Gerede OSB',
        subtitle:' ',
        category:'Güvenlik Sistemleri',
        works:[
            "Profesyonel Kamara Sistemleri(Radiolink)","Network Çözümleri"]
    },
    {
        id:3,
        img:'assets/img/portfolio/duu.jpg',
        title: 'Düzce Üniversitesi',
        subtitle:' ',
        category: 'Güvenlik Sistemleri',
        works:[
            "Profesyonel Kamara Sistemleri","Kontrollü Geçiş Sistemi","Yangın Alarm Sistemi"]
    },
    {
        id:4,
        img:'assets/img/portfolio/kuscuoğlu.jpg',
        title: 'Kuşcuoğlu İnşaat Şehr-i Bahçe',
        subtitle:' ',
        category: 'Akıllı Ev',
        works:[
            "Akıllı Ev","Profesyonel Kamera Sistemleri","Yangın Algılama Sistemleri","Hırsız Alarm Sistemleri", "Kontrollü Geçiş"]
    },
    {
        id:5,
        img:'assets/img/portfolio/sarkon-yatırım-müh.jpg',
        title: 'Sarkon Yatırım Paşa Konakları',
        subtitle:' ',
        category:'Akıllı Ev',
        works:["Akıllı Ev","Profesyonel Kamera Sistemleri","Hırsız Alarm"]
    },
    {
        id:6,
        img:'assets/img/portfolio/sivrikaya.jpg',
        title: 'Sivrikaya Yapı',
        subtitle:' ',
        category:'Akıllı Ev',
        works:["Akıllı Ev","Profesyonel Kamera Sistemleri","Hırsız Alarm"]
    },
    {
        id:7,
        img:'assets/img/portfolio/bw-ulusoy.jpg',
        title: 'BW Ulusoy İnşaat',
        subtitle:' ',
        category: 'Akıllı Ev',
        works:["Akıllı Ev","Profesyonel Kamera Sistemleri","Hırsız Alarm"]
    },
    {
        id:8,
        img:'assets/img/portfolio/mekatro.jpg',
        title: 'Mekatro Mühendislik',
        subtitle:'',
        category:'Akıllı Ev',
        works:["Akıllı Ev","Profesyonel Kamera Sistemleri","Hırsız Alarm"]
    },
    {
        id: 9,
        img: 'assets/img/portfolio/allı-turna-golden-village.jpg',
        title: 'Allıturna Yapı Golden Village',
        subtitle: ' ',
        category: 'Akıllı Ev',
        works:["Akıllı Ev","Profesyonel Kamera Sistemleri","Hırsız Alarm"]
       
    },
    {
        id: 10,
        img: 'assets/img/portfolio/kent-inşaat.jpg',
        title: 'Kent İnşaat Villa Kent',
        subtitle: ' ',
        category: 'Akıllı Ev',
        works:["Akıllı Ev","Profesyonel Kamera Sistemleri","Hırsız Alarm"]
    },
    {
        id: 11,
        img: 'assets/img/portfolio/coşkun-yapı-inşaat.jpg',
        title: 'Coşkun Yapı İnşaat',
        subtitle: ' ',
        category: 'Akıllı Ev',
        works:["Akıllı Ev","Profesyonel Kamera Sistemleri","Hırsız Alarm"]
    },
    {
        id: 12,
        img: 'assets/img/portfolio/beykoy-kgys.jpg',
        title: 'Beyköy Jandarma',
        subtitle: ' ',
        category: 'Güvenlik Sistemleri',
        works:[
            "KGYS Sistemleri","Personel Takip Sistemleri (PDKS)","Kontrollü Geçiş Sistemi"]
    },
    {
        id: 13,
        img: 'assets/img/portfolio/kaynaşlı-kgys.jpg',
        title: 'Gümüşova KGYS',
        subtitle: ' ',
        category: 'Güvenlik Sistemleri',
        works:[
            "KGYS Sistemleri","Personel Takip Sistemleri (PDKS)","Kontrollü Geçiş Sistemi"]
    },
    {
        id: 14,
        img: 'assets/img/portfolio/kaynaşlı-kgys.jpg',
        title: 'Kaynaşlı KGYS',
        subtitle: ' ',
        category: 'Güvenlik Sistemleri',
        works:[
            "KGYS Sistemleri","Personel Takip Sistemleri (PDKS)","Kontrollü Geçiş Sistemi"]
    },
    {
        id: 15,
        img: 'assets/img/portfolio/anlaş.jpg',
        title: 'Anlaş Lastik AŞ',
        subtitle: ' ',
        category: 'Güvenlik Sistemleri',
        works:[
            "Profesyonel Kamera Sistemleri","Yangın Söndürme Sistemleri","Fiber Altyapı","Fiber Çözümleri","Personel Takip Sistemleri(PDKS)","Kontrollü Geçiş Sistemleri"]
    },
    {
        id: 16,
        img: 'assets/img/portfolio/dekostil-mobilya.jpg',
        title: 'Dekostil Mobilya Dekostill Villaları',
        subtitle: ' ',
        category: 'Güvenlik Sistemleri',
        works:[
            "Akıllı Ev","Profesyonel Kamera Sistemleri","Yangın Algılama Sistemleri"," Personel Takip Sistemleri (PDKS)", "IP Santral"]
    },
    {
        id: 17,
        img: 'assets/img/portfolio/tisan.jpg',
        title: 'Tisan Mühendislik',
        subtitle: ' ',
        category: 'Güvenlik Sistemleri',
        works:[
            "Profesyonel Kamera Sistemleri","Yangın Algılama Sistemi"]
    },
    {
        id: 18,
        img: 'assets/img/portfolio/pastacı.jpg',
        title: 'Pastacı Bistro',
        subtitle: ' ',
        category: 'Güvenlik Sistemleri',
        works:[
            "Profesyonel Kamera Sistemleri","Yangın Algılama Sistemi","Personnel Takip Sistemleri (PDKS)","Akıllı Ev Sisteleri","Restoran Otomasyon","Kontrollü Geçiş Sistemleri","IP Santal Sistemleri","Hırsız Alarm"]
    },
    {
        id: 19,
        img: 'assets/img/portfolio/aden.jpg',
        title: 'Aden Boutique Hotel & Spa',
        subtitle: ' ',
        category: 'Güvenlik Sistemleri',
        works:[
            "Network Çözümleri"]
    },
    {
        id: 20,
        img: 'assets/img/portfolio/teknopark-düzce.jpg',
        title: 'Düzce Teknopark',
        subtitle: ' ',
        category: 'Güvenlik Sistemleri',
        works:[
            "Network Çözümleri"]
    },
    {
        id: 21,
        img: 'assets/img/portfolio/düzce-adalet-sarayı.jpg',
        title: 'Düzce Adalet Sarayı',
        subtitle: ' ',
        category: 'Güvenlik Sistemleri',
        works:[
            "Profesyonel Kamera Sistemleri","Kontrollü Geçiş Sistemi"]
    },
    {
        id: 22,
        img: 'assets/img/portfolio/abant-yeşil-ev.jpg',
        title: 'Abant Yeşil Ev',
        subtitle: ' ',
        category: 'Güvenlik Sistemleri',
        works:[
            "Profesyonel Kamera Sistemleri","IP Santral Çözümleri","Network Çözümleri","Restoran Otomasyon","Hırsız Alarm Sistemleri","Yangın Alarm Sistemleri"]
    },
    {
        id: 23,
        img: 'assets/img/portfolio/debateks.jpg',
        title: 'Debateks Tekstil',
        subtitle: ' ',
        category: 'Güvenlik Sistemleri',
        works:[
            "Profesyonel Kamera Sistemleri"]
    },
    {
        id: 24,
        img: 'assets/img/portfolio/gölyaka-devlet-hastanesi.jpg',
        title: 'Gölyaka Devlet Hastanesi',
        subtitle: ' ',
        category: 'Güvenlik Sistemleri',
        works:[
            "Profesyonel Kamera Sistemleri"]
    },
    {
        id: 25,
        img: 'assets/img/portfolio/teksen-koleji.jpg',
        title: 'Teksen Koleji',
        subtitle: ' ',
        category: 'Güvenlik Sistemleri',
        works:[
            "Profesyonel Kamera Sistemleri","IP Santral Çözümleri","Network Çözümleri","Kontorllü Geçiş Sistemleri","Hırsız Alarm Sistemleri","Yangın Alarm Sistemleri"]
    },
    {
        id: 26,
        img: 'assets/img/portfolio/yagmur-traktör.jpg',
        title: 'Yağmur Traktör',
        subtitle: ' ',
        category: 'Güvenlik Sistemleri',
        works:[
            "Profesyonel Kamera Sistemleri","Kontrollü Geçiş Sistemleri","Network Çözümleri"]
    },
    {
        id: 27,
        img: 'assets/img/portfolio/funny-gıda.jpg',
        title: 'Funny Gıda',
        subtitle: ' ',
        category: 'Güvenlik Sistemleri',
        works:[
            "Profesyonel Kamera Sistemleri","Personel Takip Sistemleri(PDKS)","Network Çözümleri","Kontorllü Geçiş Sistemleri","Hırsız Alarm Sistemleri","Yangın Alarm Sistemleri"]
    },
    {
        id: 28,
        img: 'assets/img/portfolio/düzce-cam.jpg',
        title: 'Düzce Cam AŞ',
        subtitle: ' ',
        category: 'Güvenlik Sistemleri',
        works:[
            "Profesyonel Kamera Sistemleri"]
    },
    {
        id: 29,
        img: 'assets/img/portfolio/realkom.jpg',
        title: 'Realkom',
        subtitle: ' ',
        category: 'Güvenlik Sistemleri',
        works:[
            "Profesyonel Kamera Sistemleri"]
    },
    {
        id: 30,
        img: 'assets/img/portfolio/propak.jpg',
        title: 'Propak',
        subtitle: ' ',
        category: 'Güvenlik Sistemleri',
        works:[
            "Profesyonel Kamera Sistemleri","Network Çözümleri"]
    },
    {
        id: 31,
        img: 'assets/img/portfolio/mate.jpg',
        title: 'Mate Drink & Dessert',
        subtitle: ' ',
        category: 'Güvenlik Sistemleri',
        works:[
            "Profesyonel Kamera Sistemleri","IP Santral Çözümleri","Network Çözümleri","Restoran Otomasyon","Hırsız Alarm Sistemleri","Yangın Alarm Sistemleri","Profesyonel Ses Sitemleri"]
    },
    {
        id: 32,
        img: 'assets/img/portfolio/son-adım-geri-dönüşüm.jpg',
        title: 'Son Adım Geri DÖnüşüm San. ve Tic. Ltd. Şti.',
        subtitle: ' ',
        category: 'Güvenlik Sistemleri',
        works:[
            "Profesyonel Kamera Sistemleri","Network Çözümleri"]
    },
    {
        id: 33,
        img: 'assets/img/portfolio/next-plastik.jpg',
        title: 'Next Plastik Kauçuk San. ve Tic. A.Ş.',
        subtitle: ' ',
        category: 'Güvenlik Sistemleri',
        works:[
            "Profesyonel Kamera Sistemleri","IP Santral Çözümleri","Network Çözümleri","Personel Takip Sistemi (PDKS)","Kontrollü Geçiş Sistemleri"]
    },
    {
        id: 34,
        img: 'assets/img/portfolio/lazpresso.jpg',
        title: 'Lazpresso Coffee',
        subtitle: ' ',
        category: 'Güvenlik Sistemleri',
        works:[
            "Hırsız Alarm Sistemleri"]
    },
    {
        id: 35,
        img: 'assets/img/portfolio/envio.jpg',
        title: 'Envio Enerji Üretim A.Ş.',
        subtitle: ' ',
        category: 'Güvenlik Sistemleri',
        works:[
            "Profesyonel Kamera Sistemleri","Network Çözümleri"]
    },
    {
        id: 36,
        img: 'assets/img/portfolio/esmak.jpg',
        title: 'Esmak',
        subtitle: ' ',
        category: 'Güvenlik Sistemleri',
        works:[
            "Profesyonel Kamera Sistemleri","IP Santral Çözümleri","Network Çözümleri","Personel Takip Sistemleri (PDKS)","Kontrollü Geçiş Sistemi","Yangın Alarm Sistemleri"]
    },
    {
        id: 37,
        img: 'assets/img/portfolio/nobel-ilaç.jpg',
        title: 'Nobel İlaç',
        subtitle: ' ',
        category: 'Güvenlik Sistemleri',
        works:[
            "Profesyonel Kamera Sistemleri","Kontrollü Geçiş Sistemleri"]
    },
    {
        id: 38,
        img: 'assets/img/portfolio/ahmet-yiğit-ağır-nakliyat.jpg',
        title: 'Ahmet Yiğit Ağır Nakliyat',
        subtitle: ' ',
        category: 'Güvenlik Sistemleri',
        works:[
            "Profesyonel Kamera Sistemleri","Hırsız Alarm Sistemleri"]
    },
    {
        id: 39,
        img: 'assets/img/portfolio/mt-plastik.jpg',
        title: 'M&T Plastik A.Ş',
        subtitle: ' ',
        category: 'Güvenlik Sistemleri',
        works:[
            "Profesyonel Kamera Sistemleri"]
    },
    {
        id: 40,
        img: 'assets/img/portfolio/standard.jpg',
        title: 'Standard Profil',
        subtitle: ' ',
        category: 'Güvenlik Sistemleri',
        works:[
           "Network Çözümleri","Kontrollü Geçiş Sistemleri"]
    },
    {
        id: 41,
        img: 'assets/img/portfolio/izmit-simge-petrol.jpg',
        title: 'İzmit Simge Petrol',
        subtitle: ' ',
        category: 'Güvenlik Sistemleri',
        works:[
            "Profesyonel Kamera Sistemleri (Radiolink)"]
    },
    {
        id: 42,
        img: 'assets/img/portfolio/rami-özel-hastanesi.jpg',
        title: 'Rami Özen Hastanesi',
        subtitle: ' ',
        category: 'Güvenlik Sistemleri',
        works:[
            "Profesyonel Kamera Sistemleri","IP Santral Çözümleri","Network Çözümleri","Personel Takip Sistemleri (PDKS)","Acil Anons Sistemleri","Yangın Alarm Sistemleri"]
    },
    {
        id: 43,
        img: 'assets/img/portfolio/karaman-döküm.jpg',
        title: 'Karaman Döküm',
        subtitle: ' ',
        category: 'Güvenlik Sistemleri',
        works:[
            "Turnike Sistemleri","Personel Takip Sistemleri (PDKS)","Kontrollü Geçiş Sistemi"]
    },
    {
        id: 44,
        img: 'assets/img/portfolio/namık-kemal-iöo.jpg',
        title: 'Namık Kemal İlköğretim Okulu',
        subtitle: ' ',
        category: 'Güvenlik Sistemleri',
        works:[
            "Profesyonel Kamera Sistemleri","IP Santral Çözümleri","Network Çözümleri","Profesyonel Ses Sistemleri","Acil Anons Sistemleri","Hırsız Alarm Sistemleri","Yangın Alarm Sistemleri"]
    },
    {
        id: 45,
        img: 'assets/img/portfolio/düzce-engelsiz-yaşam.jpg',
        title: 'Düzce Engelsiz Yaşam Merkezi',
        subtitle: ' ',
        category: 'Güvenlik Sistemleri',
        works:[
            "Profesyonel Kamera Sistemleri ","Yangın Alarm Sistemleri","IP Santral Çözümleri","Network Çözümleri","Profesyonel Ses Sistemleri","Acil Anons Sistemleri","Hemşire Çağrı Sistemleri"]
    },
    {
        id: 46,
        img: 'assets/img/portfolio/ugur-okulları.jpg',
        title: 'Uğur Okulları',
        subtitle: ' ',
        category: 'Güvenlik Sistemleri',
        works:[
            "Profesyonel Kamera Sistemleri ","Yangın Alarm Sistemleri","Hırsız Alarm Sistemleri","IP Santral Çözümleri","Network Çözümleri","Personel Takip Sistemleri","Turnike Sistemleri","Acil Anons Sistemleri","Profesyonel Ses Sistemleri"]
    },
    {
        id: 47,
        img: 'assets/img/portfolio/aytav.jpg',
        title: 'Aytav Tavukçuluk',
        subtitle: ' ',
        category: 'Güvenlik Sistemleri',
        works:[
            "Profesyonel Kamera Sistemleri"]
    },
    {
        id: 48,
        img: 'assets/img/portfolio/gropalli.jpg',
        title: 'Groppalli',
        subtitle: ' ',
        category: 'Güvenlik Sistemleri',
        works:[
            "Kontrollü Geçiş Sistemi","Turnike Sistemi"]
    },
    {
        id: 49,
        img: 'assets/img/portfolio/kasabın-mutfağı.jpg',
        title: 'Kasabın Mutfağı',
        subtitle: ' ',
        category: 'Güvenlik Sistemleri',
        works:[
            "Profesyonel Kamera Sistemleri","Hırsız Alarm Sistemleri"]
    },
    {
        id: 50,
        img: 'assets/img/portfolio/akın-ziraat.jpg',
        title: 'Akın Ziraat',
        subtitle: ' ',
        category: 'Güvenlik Sistemleri',
        works:[
            "Profesyonel Kamera Sistemleri","Hırsız Alarm Sistemleri"]
    },
    {
        id: 51,
        img: 'assets/img/portfolio/yigitler-beton.jpg',
        title: 'Yiğitler Beton',
        subtitle: ' ',
        category: 'Güvenlik Sistemleri',
        works:[
            "Profesyonel Kamera Sistemleri"]
    },
    {
        id: 52,
        img: 'assets/img/portfolio/al-alimünyum.jpg',
        title: 'Al Alüminyum',
        subtitle: ' ',
        category: 'Güvenlik Sistemleri',
        works:[
            "Profesyonel Kamera Sistemleri "]
    },
    {
        id: 53,
        img: 'assets/img/portfolio/alkan-group.jpg',
        title: 'Alkan Group',
        subtitle: ' ',
        category: 'Güvenlik Sistemleri',
        works:[
            "Profesyonel Kamera Sistemleri ","Yangın Alarm Sistemleri","Hırsız Alarm Sistemleri","IP Santral Çözümleri","Network Çözümleri","Acil Anons Sistemleri","Profesyonel Uydu Tabanlı Telsiz Sistemleri"]
    },
    {
        id: 54,
        img: 'assets/img/portfolio/arın-ormn-ürünleri.jpg',
        title: 'Arın Orman Ürünleri',
        subtitle: ' ',
        category: 'Güvenlik Sistemleri',
        works:[
            "Profesyonel Kamera Sistemleri "]
    },
    {
        id: 55,
        img: 'assets/img/portfolio/altan-kuyumculuk.jpg',
        title: 'Altan Kuyumculuk',
        subtitle: ' ',
        category: 'Akıllı Ev',
        works:[
            "Profesyonel Kamera Sistemleri ","Akıllı Ev Sistemleri","Hırsız Alarm Sistemleri","Network Çözümleri"]
    },
    {
        id: 56,
        img: 'assets/img/portfolio/bry-boya.jpg',
        title: 'BRY Boya',
        subtitle: ' ',
        category: 'Güvenlik Sistemleri',
        works:[
            "Profesyonel Kamera Sistemleri ","Yangın Alarm Sistemleri","Hırsız Alarm Sistemleri","IP Santral Çözümleri","Network Çözümleri","Personel Takip Sistemleri"]
    },
    {
        id: 57,
        img: 'assets/img/portfolio/bağdatlılar-çerez.jpg',
        title: 'Bağdatlılar Çerez',
        subtitle: ' ',
        category: 'Güvenlik Sistemleri',
        works:[
            "Profesyonel Kamera Sistemleri "]
    },
    {
        id: 58,
        img: 'assets/img/portfolio/başarı-eğitim.jpg',
        title: 'Başarı Eğitim Kurumları',
        subtitle: ' ',
        category: 'Güvenlik Sistemleri',
        works:[
            "Profesyonel Kamera Sistemleri "]
    },
    {
        id: 59,
        img: 'assets/img/portfolio/allegion.jpg',
        title: 'Allegion',
        subtitle: ' ',
        category: 'Güvenlik Sistemleri',
        works:[
            "Profesyonel Kamera Sistemleri ","Yangın Alarm Sistemleri","Network Çözümleri"]
    },
    
    {
        id: 61,
        img: 'assets/img/portfolio/burger-king.jpg',
        title: 'Burger King',
        subtitle: ' ',
        category: 'Güvenlik Sistemleri',
        works:[
            "Profesyonel Kamera Sistemleri ","Yangın Alarm Sistemleri","Hırsız Alarm Sistemleri","Network Çözümleri"]
    },
    {
        id: 62,
        img: 'assets/img/portfolio/düzce-özel-il-idaresi.jpg',
        title: 'Düzce Özel İl İdaresi',
        subtitle: ' ',
        category: 'Güvenlik Sistemleri',
        works:[
            "Profesyonel Kamera Sistemleri ","Yangın Alarm Sistemleri","IP Santral Çözümleri","Turnike Sistemleri","Kontrollü Geçiş Sistemleri","Metal Kapı Dedekötörü"]
    },
    {
        id: 63,
        img: 'assets/img/portfolio/go-petrol.jpg',
        title: 'GO Petrol',
        subtitle: ' ',
        category: 'Güvenlik Sistemleri',
        works:[
            "Profesyonel Kamera Sistemleri ","Yangın Alarm Sistemleri","Hırsız Alarm Sistemleri"]
    },
    {
        id: 64,
        img: 'assets/img/portfolio/filli-boya.jpg',
        title: 'Filli Boya',
        subtitle: ' ',
        category: 'Güvenlik Sistemleri',
        works:[
            "Profesyonel Kamera Sistemleri ","Yangın Alarm Sistemleri","Hırsız Alarm Sistemleri","IP Santral Çözümleri","Network Çözümleri","Personel Takip Sistemleri (PDKS)"]
    },
    {
        id: 65,
        img: 'assets/img/portfolio/halavet.jpg',
        title: 'Halavet',
        subtitle: ' ',
        category: 'Güvenlik Sistemleri',
        works:[
            "Profesyonel Kamera Sistemleri "]
    },
    {
        id: 66,
        img: 'assets/img/portfolio/ito-kilit.jpg',
        title: 'İTO Kilit',
        subtitle: ' ',
        category: 'Güvenlik Sistemleri',
        works:[
            "Profesyonel Kamera Sistemleri ","Personel Takip Sistemleri (PDKS)"]
    },
    {
        id: 67,
        img: 'assets/img/portfolio/lucky-bros.jpg',
        title: 'Lucky Bros',
        subtitle: ' ',
        category: 'Güvenlik Sistemleri',
        works:[
            "Profesyonel Kamera Sistemleri ","Hırsız Alarm Sistemleri"]
    },
    {
        id: 68,
        img: 'assets/img/portfolio/kps.jpg',
        title: 'KPS',
        subtitle: ' ',
        category: 'Güvenlik Sistemleri',
        works:[
            "Profesyonel Kamera Sistemleri "]
    },
    {
        id: 69,
        img: 'assets/img/portfolio/mersin-agır-nakliyat.jpg',
        title: 'Mersin Ağır Nakliyat',
        subtitle: ' ',
        category: 'Güvenlik Sistemleri',
        works:[
            "Profesyonel Kamera Sistemleri (Radiolink) "]
    },
    {
        id: 70,
        img: 'assets/img/portfolio/teb.jpg',
        title: 'TEB',
        subtitle: ' ',
        category: 'Güvenlik Sistemleri',
        works:[
           "Hırsız Alarm Sistemleri"]
    },
    {
        id: 71,
        img: 'assets/img/portfolio/deniz-bank-düzce.jpg',
        title: 'Denizbank',
        subtitle: ' ',
        category: 'Güvenlik Sistemleri',
        works:[
            "Hırsız Alarm Sistemleri"]
    },
    {
        id: 72,
        img: 'assets/img/portfolio/toyota düzce.jpg',
        title: 'Toyota',
        subtitle: ' ',
        category: 'Güvenlik Sistemleri',
        works:[
            "Yangın Alarm Sistemleri"]
    },
    {
        id: 73,
        img: 'assets/img/portfolio/woody.jpg',
        title: 'Woody',
        subtitle: ' ',
        category: 'Güvenlik Sistemleri',
        works:[
            "Profesyonel Kamera Sistemleri ","Yangın Alarm Sistemleri"]
    },
    {
        id: 74,
        img: 'assets/img/portfolio/simetri tank.jpg',
        title: 'Simetri Tank',
        subtitle: ' ',
        category: 'Güvenlik Sistemleri',
        works:[
            "Profesyonel Kamera Sistemleri ","Yangın Alarm Sistemleri","Hırsız Alarm Sistemleri","Network Çözümleri","Personel Takip Sistemleri (PDKS)"]
    },
   
    {
        id:77,
        img:'assets/img/portfolio/barıs.jpg',
        title: 'Pastacı Barış Sitesi',
        subtitle:' ',
        category: 'Akıllı Ev',
        works:[
            "Akıllı Ev"]
    },
    {
        id:78,
        img:'assets/img/portfolio/şehrinaz.jpg',
        title: 'Kuşçuoğlu İnşaat   Şehr-i Naz',
        subtitle:' ',
        category: 'Akıllı Ev',
        works:[
            "Akıllı Ev"]
    },
    {
        id:79,
        img:'assets/img/portfolio/taç-mahal.jpg',
        title: 'Kuşcuoğlu İnşaat Taçmahal',
        subtitle:' ',
        category: 'Akıllı Ev',
        works:[
            "Akıllı Ev"]
    },
    {
        id:80,
        img:'assets/img/portfolio/sivrikaya-etap.jpg',
        title: 'Sivrikaya Yapı Çamlıca Villaları 2. Etap',
        subtitle:' ',
        category: 'Akıllı Ev',
        works:[
            "Akıllı Ev"]
    },
    {
        id:81,
        img:'assets/img/portfolio/sivrikaya.jpg',
        title: 'Sivrikaya Yapı Vadi Bahçeşehir',
        subtitle:' ',
        category: 'Akıllı Ev',
        works:[
            "Akıllı Ev"]
    },
    {
        id:82,
        img:'assets/img/portfolio/bw-premium.jpg',
        title: 'BW İnşaat Preminum',
        subtitle:' ',
        category: 'Akıllı Ev',
        works:[
            "Akıllı Ev"]
    },
    {
        id:83,
        img:'assets/img/portfolio/coşkıun-yapı-casagarden.jpg',
        title: 'Coşkun Yapı Case Garden',
        subtitle:' ',
        category: 'Akıllı Ev',
        works:[
            "Akıllı Ev"]
    },
    {
        id:84,
        img:'assets/img/portfolio/noah.jpg',
        title: 'Noah İnşaat Central ',
        subtitle:' ',
        category: 'Akıllı Ev',
        works:[
            "Akıllı Ev"]
    },
    {
        id:85,
        img:'assets/img/portfolio/asya.jpg',
        title: 'MG Asya Yapı Lotus',
        subtitle:' ',
        category: 'Akıllı Ev',
        works:[
            "Akıllı Ev"]
    },
    {
        id:86,
        img:'assets/img/portfolio/kuscuoğlu.jpg',
        title: 'Kuşcuoğlu İnşaat',
        subtitle:' ',
        category: 'Akıllı Ev',
        works:[
            "Akıllı Ev"]
    },
    {
        id:87,
        img:'assets/img/portfolio/regnum.jpg',
        title: 'Ogi Yatırım Regnum Kent',
        subtitle:' ',
        category: 'Akıllı Ev',
        works:[
            "Akıllı Ev"]
    },
    {
        id:88,
        img:'assets/img/portfolio/inci-inşaat.jpg',
        title: 'İnci İnşaat İnci Villaları',
        subtitle:' ',
        category: 'Akıllı Ev',
        works:[
            "Akıllı Ev"]
    },
    {
        id:89,
        img:'assets/img/portfolio/çağrı-koç.jpg',
        title: 'Koç İnşaat ',
        subtitle:' ',
        category: 'Akıllı Ev',
        works:[
            "Akıllı Ev"]
    },
    {
        id:90,
        img:'assets/img/portfolio/kuscuoğlu.jpg',
        title: 'Özşen İnşaat Şen Villaları',
        subtitle:' ',
        category: 'Akıllı Ev',
        works:[
            "Akıllı Ev"]
    },
    {
        id:91,
        img:'assets/img/portfolio/kuscuoğlu.jpg',
        title: 'Bulvar Sürücü Kursu Güvenç Yılmaz',
        subtitle:' ',
        category: 'Akıllı Ev',
        works:[
            "Akıllı Ev"]
    },
    {
        id:92,
        img:'assets/img/portfolio/allıturna-green-village.jpg',
        title: 'Allıturna Yapı Green Village',
        subtitle:' ',
        category: 'Akıllı Ev',
        works:[
            "Akıllı Ev"]
    },
    {
        id:93,
        img:'assets/img/portfolio/bozkus.jpg',
        title: 'Bozkuşlar İnşaat Bozkuş Life 2 - 3',
        subtitle:' ',
        category: 'Akıllı Ev',
        works:[
            "Akıllı Ev"]
    },
    {
        id:94,
        img:'assets/img/portfolio/bozkus.jpg',
        title: 'Bozkuşlar İnşaat Bozkuş Life 4',
        subtitle:' ',
        category: 'Akıllı Ev',
        works:[
            "Akıllı Ev"]
    },  {
        id:95,
        img:'assets/img/portfolio/semih-pak.jpg',
        title: 'Pak Mimarlık Aksu Villası',
        subtitle:' ',
        category: 'Akıllı Ev',
        works:[
            "Akıllı Ev"]
    },
    {
        id:95,
        img:'assets/img/portfolio/turgay-cimen.jpg',
        title: 'Turgay Çimen',
        subtitle:' ',
        category: 'Akıllı Ev',
        works:[
            "Akıllı Ev"]
    },
    {
        id:96,
        img:'assets/img/portfolio/eldivan-inşaat.jpg',
        title: 'Eldivan İnşaat Koza Villaları',
        subtitle:' ',
        category: 'Akıllı Ev',
        works:[
            "Akıllı Ev"]
    },
    {
        id:97,
        img:'assets/img/portfolio/ahmet-veli.jpg',
        title: 'Bilsoft Ahmet Veli ',
        subtitle:' ',
        category: 'Akıllı Ev',
        works:[
            "Akıllı Ev"]
    },
    {
        id:98,
        img:'assets/img/portfolio/serdar-kumas.jpg',
        title: 'Serdar Kumaş - Bolu ',
        subtitle:' ',
        category: 'Akıllı Ev',
        works:[
            "Akıllı Ev"]
    },
    {
        id:99,
        img:'assets/img/portfolio/emre-öztürk.jpg',
        title: 'Emre Öztürk ',
        subtitle:' ',
        category: 'Akıllı Ev',
        works:[
            "Akıllı Ev"]
    },
    {
        id:100,
        img:'assets/img/portfolio/aşoğlu.jpg',
        title: 'Aşoğlu İnşaat Sapanca ',
        subtitle:' ',
        category: 'Akıllı Ev',
        works:[
            "Akıllı Ev"]
    },
    {
        id:101,
        img:'assets/img/portfolio/kuscuoğlu.jpg',
        title: ' Vera Hayvancılık - Bolu ',
        subtitle:' ',
        category: 'Akıllı Ev',
        works:[
            "Akıllı Ev"]
    },
    {
        id:102,
        img:'assets/img/portfolio/turgay-demeldas.jpg',
        title: 'Pak Mimarlık Turgay Temaldaş ',
        subtitle:' ',
        category: 'Akıllı Ev',
        works:[
            "Akıllı Ev"]
    },
    {
        id:103,
        img:'assets/img/portfolio/muhammet-erzurum.jpg',
        title: 'Peli Parke Muhammet Erzurum ',
        subtitle:' ',
        category: 'Akıllı Ev',
        works:[
            "Akıllı Ev"]
    },
    {
        id:104,
        img:'assets/img/portfolio/arzu-kuşcuoğlu.jpg',
        title: 'Eldivan İnşaat Arzu Kuşcuoğlu',
        subtitle:' ',
        category: 'Akıllı Ev',
        works:[
            "Akıllı Ev"]
    },
    {
        id:105,
        img:'assets/img/portfolio/cagrı.jpg',
        title: 'Çağrı Özkan',
        subtitle:' ',
        category: 'Akıllı Ev',
        works:[
            "Akıllı Ev"]
    },
    {
        id:106,
        img:'assets/img/portfolio/pak-mim-emine.jpg',
        title: 'Pak Mimarlık Emine Aktürk ',
        subtitle:' ',
        category: 'Akıllı Ev',
        works:[
            "Akıllı Ev"]
    },
    {
        id:107,
        img:'assets/img/portfolio/engin-karaduman.jpg',
        title: 'Engin Karaduman ',
        subtitle:' ',
        category: 'Akıllı Ev',
        works:[
            "Akıllı Ev"]
    },
    {
        id:108,
        img:'assets/img/portfolio/enver-ayyıldız.jpg',
        title: 'Enver Ayyıldız ',
        subtitle:' ',
        category: 'Akıllı Ev',
        works:[
            "Akıllı Ev"]
    },
    {
        id:109,
        img:'assets/img/portfolio/altuntas.jpg',
        title: 'Altuntaş İnşaat- Bolu ',
        subtitle:' ',
        category: 'Akıllı Ev',
        works:[
            "Akıllı Ev"]
    },
    {
        id:110,
        img:'assets/img/portfolio/kalekimya.jpg',
        title: 'Kale Kimya Düzce ',
        subtitle:' ',
        category: 'Güvenlik Sistemleri',
        works:[
            "Network Sistemleri"]
    },
    {
        id:111,
        img:'assets/img/portfolio/2_hasel.jpg',
        title: 'Hasel Düzce ',
        subtitle:' ',
        category: 'Güvenlik Sistemleri',
        works:[
            "Network Sistemleri"]
    },   {
        id:112,
        img:'assets/img/portfolio/gani_düzce.jpg',
        title: 'Gani Düzce ',
        subtitle:' ',
        category: 'Güvenlik Sistemleri',
        works:[
            "Network Sistemleri"]
    },   {
        id:113,
        img:'assets/img/portfolio/happymoons_düzce.jpg',
        title: 'Happymoons Düzce ',
        subtitle:' ',
        category: 'Güvenlik Sistemleri',
        works:[
            "Network Sistemleri"]
    },   {
        id:114,
        img:'assets/img/portfolio/hasmer_düzce.jpg',
        title: 'Hasmer Düzce ',
        subtitle:' ',
        category: 'Güvenlik Sistemleri',
        works:[
            "Network Sistemleri"]
    },
    {
        id:114,
        img:'assets/img/portfolio/kalekimya.jpg',
        title: 'Kale Kimya Düzce ',
        subtitle:' ',
        category: 'Güvenlik Sistemleri',
        works:[
            "Network Sistemleri"]
    },
    {
        id:115,
        img:'assets/img/portfolio/arti_insaat.jpeg',
        title: 'Artı İnşaat ',
        subtitle:' ',
        category: 'Akıllı Ev',
        works:[
            "Akıllı Ev"]
    },
    {
        id:116,
        img:'assets/img/portfolio/bozkuslar_insaat.jpeg',
        title: 'Bozkuşlar İnşaat ',
        subtitle:' ',
        category: 'Akıllı Ev',
        works:[
            "Akıllı Ev"]
    },
    {
        id:117,
        img:'assets/img/portfolio/coskun_yemek.jpeg',
        title: 'Çoşkun Yemek ',
        subtitle:' ',
        category: 'Güvenlik Sistemleri',
        works:[
            "Profesyonel Kamera Sistemleri, PDKS Sistemleri"]
    },
    {
        id:118,
        img:'assets/img/portfolio/mt_tanrikulu_baglik_projesi.jpeg',
        title: 'MT Tanrıkulu Bağlık Projesi',
        subtitle:' ',
        category: 'Akıllı Ev',
        works:[
            "Akıllı Ev"]
    },
    {
        id:119,
        img:'assets/img/portfolio/pak_yapi_lavantin_konaklari.jpeg',
        title: 'PAK Yapı Lavantin Konakları',
        subtitle:' ',
        category: 'Akıllı Ev',
        works:[
            "Akıllı Ev"]
    },
    {
        id:120,
        img:'assets/img/portfolio/rifat_usulu.jpeg',
        title: 'Rıfat Usulü',
        subtitle:' ',
        category: 'Güvenlik Sistemleri',
        works:[
            "Profesyonel Kamera Sistemleri, Yangın Alarm Sistemleri,Network Sistemleri, PDKS "]
    },
    {
        id:121,
        img:'assets/img/portfolio/saf_holland.jpeg',
        title: 'SAF Holland ',
        subtitle:' ',
        category: 'Güvenlik Sistemleri',
        works:[
            "Profesyonel Kamera Sistemleri"]
    },
    {
        id:122,
        img:'assets/img/portfolio/sivrikaya_vadi_bahcesehir.jpeg',
        title: 'Sivrikaya İnşaat Vadi Bahçeşehir',
        subtitle:' ',
        category: 'Akıllı Ev',
        works:[
            "Akıllı Ev"]
    },
    {
        id:123,
        img:'assets/img/portfolio/zer_life.jpeg',
        title: 'ZER Life ',
        subtitle:' ',
        category: 'Akıllı Ev',
        works:[
            "Akıllı Ev"]
    },
    {
        id:124,
        img:'assets/img/portfolio/zi_yapi.jpeg',
        title: 'Zİ Yapı ',
        subtitle:' ',
        category: 'Akıllı Ev',
        works:[
            "Akıllı Ev"]
    },
]

export default portfolioData;